import React from 'react';
import { useApp } from '../../context/AppContext';

const TYPE_CONFIG = {
  success: { icon: 'ti-check',        color: '#22C55E', bg: '#1A202C' },
  error:   { icon: 'ti-alert-circle', color: '#EF4444', bg: '#1A202C' },
  info:    { icon: 'ti-info-circle',  color: '#60A5FA', bg: '#1A202C' },
};

export default function Toast() {
  const { toastMsg, toastVisible, toastType } = useApp();
  const cfg = TYPE_CONFIG[toastType] || TYPE_CONFIG.success;

  return (
    <div style={{
      position: 'fixed', bottom: '24px', left: '50%',
      transform: `translateX(-50%) translateY(${toastVisible ? '0' : '20px'})`,
      background: cfg.bg, color: 'white',
      padding: '10px 20px', borderRadius: '10px',
      fontSize: '13px', fontWeight: '600',
      boxShadow: '0 8px 24px rgba(0,0,0,.3)',
      zIndex: 9999,
      opacity: toastVisible ? 1 : 0,
      transition: 'all .25s',
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      maxWidth: '90vw',
      display: 'flex', alignItems: 'center', gap: '8px',
    }}>
      <i className={`ti ${cfg.icon}`} style={{ color: cfg.color, fontSize: '15px' }} />
      {toastMsg}
    </div>
  );
}
